import { useEffect, useState } from 'react';
import { useLocation, useNavigate, Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { Button, Accordion, Card, Row, Col, Form } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import Header from '../../common/Header/Header';
import { Formik } from 'formik';
import GenericButton from '../../common/button/GenericButton/GenericButton';
import ToastMessage from '../../common/ToastMessage/index';
import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';
import './EditUserRequest.scss';
import { BackAvatarSVG } from '../../../img/GlobalSVG';
const EditUserRequest = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const user = location?.state && location.state;
  const [formData, setFormData] = useState(user?.affliationData);
  const [loader, setLoader] = useState(false);
  console.log('formData', formData);
  const schema = yup.object({
    FirstName: yup.string().max(35, ' Enter maximum 35 characters only'),

    MiddleName: yup.string().max(35, ' Enter maximum 35 characters only'),
    LastName: yup.string().max(60, ' Enter maximum 60 characters only'),

    UserID: yup
      .string()
      .email('Enter Valid email Address')
      .required('Email Required'),
  });
  const handleInput = (e, setFieldValue, handleChange) => {
    handleChange(e);

    setFormData({ ...formData, [e.currentTarget.name]: e.currentTarget.value });
    setFieldValue(e.currentTarget.name, e.currentTarget.value);
  };
  const selectDoctors = {};
  if (user.doctorFacilityFlag === 'facility') {
    user?.preSelectedData &&
      user?.preSelectedData?.map((item) => {
        if (item?.PhysicianOid && item?.PhysicianOid.length > 0) {
          const foid = item?.FacilityDetails[0]?.FacilityOID;
          selectDoctors[foid] = item?.FacilityDetails[0]?.PhysicianDetails;
        }
      });
  }
  const [selectedDoctorsData, setSelectedDoctorsData] = useState(
    user.doctorFacilityFlag === 'doctor'
      ? user?.preSelectedData
        ? user?.preSelectedData
        : []
      : [],
  );
  const [selectedFacilityData, setSelectedFacilityData] = useState(
    user.doctorFacilityFlag === 'facility'
      ? user?.preSelectedData?.map((item) => item?.FacilityDetails[0]) || []
      : [],
  );
  const [selectedFacilityDoctors, setSelectedFacilityDoctors] = useState(
    selectDoctors || [],
  );
  const updateProviderInfo = async (values) => {
    setLoader(true);
    let affliationData = [];
    let apiPayload;

    user.doctorFacilityFlag === 'doctor'
      ? (affliationData = selectedDoctorsData)
      : (affliationData = selectedFacilityData);
    const affliations = [];
    affliationData &&
      affliationData.map((data) => {
        const Physician = [];
        if (user.doctorFacilityFlag === 'doctor') {
          Physician.push({
            PhysicianOid: data?.PhysicainOid,
            ConnectorId: data?.ConnectorID,
          });
          affliations.push({
            FacilityOid: data.FacilityOid,
            PhysicianData: Physician && Physician,
          });
        } else {
          for (const key in selectedFacilityDoctors) {
            if (key === data?.FacilityOID) {
              selectedFacilityDoctors[key] &&
                selectedFacilityDoctors[key].map((item) => {
                  Physician.push({
                    PhysicianOid: item?.PhysicainOid,
                    ConnectorId: item?.ConnectorID,
                  });
                });
            }
          }
          affliations.push({
            FacilityOid: data.FacilityOID,
            PhysicianData: Physician && Physician,
          });
        }
      });
    console.log('affliations', affliations);
    try {
      apiPayload = {
        UpdateUser: {
          Oid: formData.Oid,
          FirstName: formData.FirstName,
          MiddleName:
            formData.MiddleName !== undefined ? formData.MiddleName : '',
          LastName: formData.LastName,
          Status: 'Pending',
          UserType: 'Provider',
          SuperUser: false,
          UserID: formData.UserID,
          UserProviderAffiliationDetails: affliations,
          IsDoctorFacility: user.doctorFacilityFlag === 'doctor' ? true : false,
        },
      };

      const response = await axiosInstance.put(
        APIEndpoints.updateUserProviderSelfRegistration(),
        apiPayload,
      );
      //updateProviderSelfRegistration
      if (
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200 ||
        response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_201
      ) {
        toast.success(
          <ToastMessage
            type="success"
            subTitle={'User Profile has been updated successfully.'}
          />,
        );
      }
      handleOnCancel();
    } catch (error) {
      console.log(error);

      toast.error(
        <ToastMessage
          type="error"
          subTitle={
            'Something went wrong! User Profile could not be updated. Try again later.'
          }
        />,
      );
    } finally {
      setLoader(false);
    }
  };
  const handleOnCancel = () => {
    navigate(`/admin/approval-requests?trx=${formData.Oid}`, {
      state: {
        recordIndex: location.state.recordIndex,
        previousState: location.state.previousState,
      },
    });
    //navigate({ pathname: '/admin/configure-links' });
  };
  return (
    <div className="approval-edit-request-container">
      <div className="d-flex align-items-center border-bottom">
        <div className="back-arrow col cursor-pointer">
          <div aria-label="back button" onClick={handleOnCancel} to="#">
            <BackAvatarSVG.BackArrowSVG />
          </div>
        </div>
        <div className="col">
          <h1 id="greetings-time" className=" p-0 pb-2">
            Edit User Profile
          </h1>
        </div>
      </div>

      <div className="mt-3 request-edit-panel">
        <div className="edit-user">
          <div className="user-title border-bottom">User Profile</div>
          <div className="edit-section">
            <Formik
              validationSchema={schema}
              initialValues={{
                FirstName: '',
                MiddleName: '',
                LastName: '',
                UserID: '',
              }}
              enableReinitialize
              //onSubmit={async (values) => {
              //handleSubmit(values);
              //}}
            >
              {({
                values,
                touched,
                errors,
                status,
                //handleSubmit,
                handleChange,
                handleBlur,
                setStatus,
                setFieldValue,
              }) => {
                return (
                  <Form className="edituser-form">
                    <Row>
                      <Col md={12} lg={12} sm={12}>
                        <Form.Group controlId="linkBlockTitleFormGroup">
                          <Form.Label>First Name</Form.Label>

                          <Form.Control
                            type="text"
                            className=""
                            placeholder=""
                            spellCheck="off"
                            name="FirstName"
                            autoCorrect="off"
                            autoComplete="off"
                            autoFocus={false}
                            //onBlur={handleBlur}
                            //onChange={handleChange}
                            onChange={(e) => {
                              handleInput(e, setFieldValue, handleChange);
                            }}
                            onBlur={(e) => {
                              handleInput(e, setFieldValue, handleChange);
                            }}
                            value={formData.FirstName}
                            isInvalid={touched.FirstName && errors.FirstName}
                          />

                          <Form.Control.Feedback type="invalid">
                            <span role="alert">
                              {touched.FirstName && errors.FirstName}
                            </span>
                          </Form.Control.Feedback>
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} lg={12} sm={12}>
                        <Form.Group className="mb-4">
                          <Form.Label className="mb-0">Middle Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="MiddleName"
                            placeholder=""
                            className={
                              status && status.MiddleName ? 'is-invalid' : ''
                            }
                            value={formData.MiddleName}
                            isInvalid={touched.MiddleName && errors.MiddleName}
                            onChange={(e) => {
                              handleInput(e, setFieldValue, handleChange);
                            }}
                            onBlur={(e) => {
                              handleInput(e, setFieldValue, handleChange);
                            }}
                          />
                          {status && status.MiddleName ? (
                            <Form.Control.Feedback
                              type="invalid"
                              className="mt-1"
                            >
                              <span>{status.MiddleName}</span>
                            </Form.Control.Feedback>
                          ) : (
                            errors.MiddleName && (
                              <Form.Control.Feedback
                                type="invalid"
                                className="mt-1"
                              >
                                <span>
                                  {touched.MiddleName && errors.MiddleName}
                                </span>
                              </Form.Control.Feedback>
                            )
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} lg={12} sm={12}>
                        <Form.Group className="mb-4">
                          <Form.Label className="mb-0">Last Name</Form.Label>
                          <Form.Control
                            type="text"
                            name="LastName"
                            placeholder=""
                            className={
                              status && status.LastName ? 'is-invalid' : ''
                            }
                            value={formData.LastName}
                            isInvalid={touched.LastName && errors.LastName}
                            onChange={(e) => {
                              handleInput(e, setFieldValue, handleChange);
                            }}
                            onBlur={(e) => {
                              handleInput(e, setFieldValue, handleChange);
                            }}
                          />
                          {status && status.LastName ? (
                            <Form.Control.Feedback
                              type="invalid"
                              className="mt-1"
                            >
                              <span>{status.LastName}</span>
                            </Form.Control.Feedback>
                          ) : (
                            errors.LastName && (
                              <Form.Control.Feedback
                                type="invalid"
                                className="mt-1"
                              >
                                <span>
                                  {touched.LastName && errors.LastName}
                                </span>
                              </Form.Control.Feedback>
                            )
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12} lg={12} sm={12}>
                        <Form.Group className="mb-4">
                          <Form.Label className="mb-0">
                            Email/Username
                          </Form.Label>
                          <Form.Control
                            type="UserID"
                            name="UserID"
                            placeholder=""
                            className={
                              status && status.UserID ? 'is-invalid' : ''
                            }
                            value={formData.UserID}
                            isInvalid={touched.UserID && errors.UserID}
                            onChange={(e) => {
                              handleInput(e, setFieldValue, handleChange);
                            }}
                            onBlur={(e) => {
                              handleInput(e, setFieldValue, handleChange);
                            }}
                          />
                          {status && status.UserID ? (
                            <Form.Control.Feedback
                              type="invalid"
                              className="mt-1"
                            >
                              <span>{status.UserID}</span>
                            </Form.Control.Feedback>
                          ) : (
                            errors.UserID && (
                              <Form.Control.Feedback
                                type="invalid"
                                className="mt-1"
                              >
                                <span>{touched.UserID && errors.UserID}</span>
                              </Form.Control.Feedback>
                            )
                          )}
                        </Form.Group>
                      </Col>
                    </Row>
                    {/*Form Buttons Block starts here */}
                    <Form.Group
                      className="form-block"
                      controlId="buttonsFormGroup"
                    >
                      <Row>
                        <Col className="d-flex justify-content-end">
                          <GenericButton
                            variant="link"
                            onClick={handleOnCancel}
                          >
                            <b>{t('label_cancel')}</b>
                          </GenericButton>

                          <GenericButton onClick={updateProviderInfo}>
                            <b>{t('label_save')}</b>
                          </GenericButton>
                        </Col>
                      </Row>
                    </Form.Group>
                    {/*Form Buttons Block ends here */}
                  </Form>
                );
              }}
            </Formik>
          </div>
        </div>
        <div className="right-side-content"></div>
      </div>
      <div className="toastify">
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </div>
    </div>
  );
};
export default EditUserRequest;
